import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import NewSender from "@/pages/senders/New/Index";

export const Route = createFileRoute("/_market/senders/new")({
	component: () => (
		<DashboardLayout>
			<NewSender />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
